import type { ButtonHTMLAttributes, ReactNode } from "react";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  variant?: "primary" | "secondary" | "ghost" | "dark";
};

export function Button({ children, className = "", variant = "primary", ...props }: ButtonProps) {
  return (
    <button type="button" className={`button button-${variant} ${className}`.trim()} {...props}>
      {children}
    </button>
  );
}
